/* eslint-disable */
export default {
  sureToDeleteVoiceMail: '確定要刪除此語音訊息嗎？',
  sureToDeleteFax: '確定要刪除此傳真嗎？',
  doNotAskAgain: '不再詢問',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
